import script from "./DetailBody.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailBody.vue?vue&type=script&setup=true&lang=js"

import "./DetailBody.vue?vue&type=style&index=0&id=7706d60f&lang=css"

const __exports__ = script;

export default __exports__